import { generateMedia } from 'styled-media-query'

// NOTE: BreakPointの考え方はtailwindと同じく、@media(min-width: 768px)のように定義する
export const BreakPoints = {
  tablet: '768px',
  laptop: '1024px',
}
// styled-media-queryで定義されたBreakPointを使用する場合は generateMedia を使用する
const media = generateMedia(BreakPoints)

export const mediaQuery = {
  /** Laptopサイズ以上に適用 */
  greaterLaptop: media.greaterThan('laptop'),
  /** Tabletサイズ以上に適用 */
  greaterTablet: media.greaterThan('tablet'),
}
